import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useDecode from "hooks/useDecode";
import useGetAdministrationSheets from "services/recordSheets/useGetAdministrationSheets";
import EntornoLaboral from "../Comun/EntornoLaboral";
import LoaderMin from "components/blocks/Loader/LoaderMin";
import { SheetPage, SheetHero, SheetPill, SheetSection, SheetGrid, SheetField, SheetDiagnosisField, SheetTextField, formatText, formatDate, formatBoolean, buildEntornoLaboralProps } from "../SheetLayout";

const ParteAltaBaja: React.FC<{ tituloPateAltaBaja?: (titulo: string) => void }> = ({ tituloPateAltaBaja }) => {
  const params = useParams<{ detailId: string; id: string }>();
  const parteId = params.detailId?.split("__")[1];
  const prestacionId = params.id.split("_")[1];
  const { dataAdministrationSheet: d, loadingAdministrationSheet, errorAdministrationSheet, getDischargeLeavePart } = useGetAdministrationSheets();
  const userId = useDecode("token")?.extension_id;

  useEffect(() => { getDischargeLeavePart(userId, prestacionId, parteId); }, []);

  useEffect(() => {
    if (typeof tituloPateAltaBaja === "function") {
      tituloPateAltaBaja(d?.tipoParteDescripcion || "");
    }
  }, [d, tituloPateAltaBaja]);

  if (loadingAdministrationSheet) return <section className="container"><LoaderMin /></section>;
  if (errorAdministrationSheet) return <section className="container"><p className="loader-text">Lo sentimos, se ha producido un error.</p></section>;
  if (!d) return <section className="container"><p className="loader-text">No hay datos para mostrar.</p></section>;

  return (
    <SheetPage>
      <SheetHero
        title={d.tipoParteDescripcion || "Parte Alta/Baja"}
        icon="activity"
        pills={<>
          <SheetPill label="Fecha accidente" value={formatDate(d.fechaAccidente)} icon="calendar" />
          <SheetPill label="Fecha baja"      value={formatDate(d.fechaBaja)} />
          <SheetPill label="Fecha alta"      value={formatDate(d.fechaAlta)} />
        </>}
      />

      <SheetSection title="Detalles" icon="file-text">
        <SheetGrid>
          <SheetField label="Tipo de parte"                     value={formatText(d.tipoParteDescripcion)} />
          <SheetField label="Fecha accidente"                   value={formatDate(d.fechaAccidente)} />
          <SheetField label="Fecha de baja"                     value={formatDate(d.fechaBaja)} />
          <SheetField label="Fecha de alta"                     value={formatDate(d.fechaAlta)} />
          <SheetField label="Recaída"                           value={formatBoolean(d.habilitarCheckRecaida)} />
          <SheetField label="Fecha baja Proc. Inicial Recaída"  value={formatDate(d.fechaBajaProcInicialRecaida)} />
          <SheetField label="Determinación de contingencia"     value={formatBoolean(d.esDeterminacionContingencia)} />
          <SheetField label="Tipo de proceso"                   value={formatText(d.tipoProcesoDescripcion)} />
          <SheetField label="Duración estimada (días)"          value={formatText(d.duracionEstimadaDias)} />
          <SheetField label="Fecha revisión sig. reconocimiento" value={formatDate(d.fechaRevision)} />
          <SheetField label="Gravedad"                          value={formatText(d.gravedadDescripcion)} />
          <SheetField label="Causa alta"                        value={formatText(d.causaAltaDescripcion)} wide />
          <SheetField label="Limitación Funcional"              value={formatText(d.limitacionFuncional)} wide />
          <SheetField label="Reconocimiento Médico"             value={formatText(d.medical_examination)} wide />
          <SheetDiagnosisField label="Diagnóstico CIE9MC"  code={d.codigoDiagnosticoCIE9 || ""} desc={d.diagnostico || ""} wide />
          <SheetDiagnosisField label="Diagnóstico CIE10"   code={d.diagnosticoCIE10 || ""} desc={d.diagnosticoCIE10Descripcion || ""} wide />
          <SheetDiagnosisField label="Código ocupación CNO" code={d.CNO || ""} desc={d.CNODescripcion || ""} wide />
          <SheetDiagnosisField label="Centro Sanitario"     code={d.codigoCentro || ""} desc={d.descripcionCentro || ""} />
          <SheetTextField label="Descripción del accidente" value={d.descripcionAccidente || ""} wide />
        </SheetGrid>
      </SheetSection>

      <SheetSection title="Facultativo" icon="users">
        <SheetGrid cols={3}>
          <SheetField label="Médico"           value={formatText(d.nombreFacultativo)} />
          <SheetField label="Número colegiado" value={formatText(d.numeroFacultativo)} />
          <SheetField label="CIAS médico"      value={formatText(d.ciasFacultativo)} />
        </SheetGrid>
      </SheetSection>

      {d.entornoLaboral && <EntornoLaboral {...buildEntornoLaboralProps(d)} />}
    </SheetPage>
  );
};

export default ParteAltaBaja;
